// extracted by mini-css-extract-plugin
export default {"pollsContainer":"AddPollDialog_pollsContainer__Hhu-q","buttonContainer":"AddPollDialog_buttonContainer__r0fMu"};